export default {
  name: "ImpactEcosystemSection",

  data() {
    return ({
      impact_data: {
        kicker: "The Perpetual Impact Engine",
        title: "A Closed-Loop Impact Ecosystem",
        description:
          "We don't just fund relief — we capitalize entrepreneurs. Your donation enters a perpetual engine that keeps generating impact.",
      },

      impact_steps: [
        {
          key: "capital_enters",
          number: "01",
          title: "Capital Enters",
          text:
            "Your donation flows into the EPF Sustainable Social Impact Fund, managed by Effectus Capital.",
        },
        {
          key: "asset_deployed",
          number: "02",
          title: "Asset Deployed",
          text:
            "Capital purchases standardized business units — mobile food carts, tech hubs, creative kits, or donation terminals.",
        },
        {
          key: "entrepreneur_earns",
          number: "03",
          title: "Entrepreneur Earns",
          text:
            "Vetted entrepreneurs operate the assets, earning market revenue and building sustainable livelihoods.",
        },
        {
          key: "profits_recycle",
          number: "04",
          title: "Profits Recycle",
          text:
            "A 10–25% profit share flows back to the fund, capitalizing the next wave of entrepreneurs perpetually.",
        },
      ],
    });
  },
};
